import React from 'react';
import { Container, Heading, SimpleGrid, Box } from '@hover/blueprint';
import { ABOUT_PAGE_BETTER_FOR_EVERYONE } from '../../../constants';
import BetterForEveryoneCard from './BetterForEveryoneCard';

const HomePageBetterForEveryone: React.FC = () => (
  <Box
    w="100%"
    alignItems="center"
    bg="brandTan.100"
    pt={{ base: '76px', desktop: 900 }}
    mb={{ base: '56px', tablet: 1000, desktop: '120px' }}
  >
    <Container
      maxW="1200px"
      px={500}
      pb={{ base: 700, tablet: '98px', desktop: '114px' }}
    >
      <Heading
        size={{ base: 500, tablet: 600, desktop: 700 }}
        marginBottom={{ base: '52px', tablet: '52px', desktop: '52px' }}
        isLight
      >
        Better for Everyone
      </Heading>
      <SimpleGrid
        spacingX={{ base: 400, desktop: 600 }}
        spacingY={{ base: 300, desktop: 0 }}
        columns={{ base: 2, desktop: 4 }}
      >
        {ABOUT_PAGE_BETTER_FOR_EVERYONE.map(cardItem => (
          <BetterForEveryoneCard card={cardItem} key={cardItem.id} />
        ))}
      </SimpleGrid>
    </Container>
  </Box>
);

export default HomePageBetterForEveryone;
